import ReportCard from './ReportCard'

export default ReportCard
